import store from '@/store';

export const authenticate = async (to, from, next) => {
  const hasNoUser = !store.state.user.currentUser;
  if (hasNoUser) {
    // if authorized, but user is unknown
    await store.dispatch('user/init');
  }
  next();
};
